import script from "./FlirtTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlirtTab.vue?vue&type=script&setup=true&lang=ts"

import "./FlirtTab.vue?vue&type=style&index=0&id=2ed58005&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ed58005"]])

export default __exports__